// src/utils/parseStack.js
export function parseErrorStack(stack) {
  const match = stack?.match(/\((.*):(\d+):(\d+)\)/)
  if (!match) return {}
  return {
    filename: match[1],
    lineno: Number(match[2]),
    colno: Number(match[3]),
  }
}
